import { makeAutoObservable } from "mobx";
import {
    deleteMedicalSupply,
    getMedicalSupplyById,
    pagingMedicalSupply,
    saveOrUpdateMedicalSupply,
    getAllMedicalSupply,
    saveMedicalSupplySyncStore
} from 'app/services/MedicalSupplyService';

import { BaseSearchObject, SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { MedicalSupply } from "app/common/Model/MedicalSupply";
import { checkSearchObject } from "app/common/LocalFunction";

export default class MedicalSupplyStore {
    listAllMedicalSupply = [];
    searchMedicalSupply = new SearchObject();
    pageMedicalSupply = null;
    selectedMedicalSupply = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;
    openSyncStore = false
    searchMedical = {
        ...new BaseSearchObject(),
    }

    constructor() {
        makeAutoObservable(this);
    }

    getAllMedicalSupply = async () => {
        if (this.listAllMedicalSupply?.length === 0 || this.recentlyUpdated) {
            getAllMedicalSupply()
                .then(({ data }) => {
                    this.listAllMedicalSupply = data;
                    this.recentlyUpdated = false;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu đơn vị tính có lỗi")
                })
        }
    }

    pagingMedicalSupply = async () => {
        return await pagingMedicalSupply(this.searchMedicalSupply)
            .then(({ data }) => {
                this.pageMedicalSupply = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu đơn vị tính có lỗi")
            })
    }
    pagingMedical = async () => {
        return await pagingMedicalSupply(this.searchMedical)
            .then(({ data }) => {
                this.pageMedicalSupply = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu đơn vị tính có lỗi")
            })
    }
    handleChangeFormSearch = (searchMedicalSupply) => {
        this.searchMedicalSupply = checkSearchObject(this.searchMedicalSupply, searchMedicalSupply);
        this.pagingMedicalSupply();
    }
    handleChangeFormSearchMedical = (searchMedicalSupply) => {
        this.searchMedical = { ...this.searchMedical, ...searchMedicalSupply }
        this.pagingMedical();
    }

    handleOpenFormCreateOrEdit = (medicalSupplyId) => {
        if (Boolean(medicalSupplyId)) {
            getMedicalSupplyById(medicalSupplyId).then(({ data }) => {
                this.selectedMedicalSupply = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedMedicalSupply = new MedicalSupply();
            this.openFormCreateOrEdit = true;
        }
    }

    saveOrUpdateMedicalSupply = (medicalSupply, { setSubmitting }) => {
        saveOrUpdateMedicalSupply(medicalSupply)
            .then(() => {
                this.selectedMedicalSupply = null;
                toast.success("Lưu đơn vị tính thành công!");
                this.handleClosePopup();
                this.pagingMedicalSupply();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu đơn vị tính có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (medicalSupply) => {
        this.selectedMedicalSupply = { id: medicalSupply?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteMedicalSupply(this.selectedMedicalSupply?.id)
            .then(() => {
                if (this.searchMedicalSupply?.pageIndex > 1 && this.pageMedicalSupply?.content?.length === 1) {
                    this.searchMedicalSupply.pageIndex -= 1;
                }
                toast.success("Xóa đơn vị tính thành công!");
                this.handleClosePopup();
                this.pagingMedicalSupply();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa đơn vị tính có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    handleOpenSyncStore = () => {
        this.openSyncStore = true
    }

    handleCloseSyncStore = () => {
        this.openSyncStore = false
    }

    handleSaveSyncStore = (data, { setSubmitting }) => {
        saveMedicalSupplySyncStore(data).then(() => {
            this.openSyncStore = false;
            toast.success("Đồng bộ thuốc thành công")
            this.pagingMedicalSupply()
        }).catch((err) => {
            toast.error("Đồng bộ thuốc thất bại")
        }).finally(() => {
            setSubmitting(false)
        })
    }

    resetStore = () => {
        this.searchMedicalSupply = new SearchObject();
        this.pageMedicalSupply = null;
        this.selectedMedicalSupply = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
        this.searchMedical = { ...new BaseSearchObject(), }
    }


    //for choosing
    listMedicalSupply = [];
    medicalSupplyIdSet = null;

    idValidMedicalSupply = medicalSupply => {
        if (medicalSupply && (medicalSupply?.id || medicalSupply?.medicalSupplyId)) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addMedicalSupply = medicalSupply => {
        if (!this.idValidMedicalSupply(medicalSupply)) return;
        this.listMedicalSupply.push(medicalSupply);
        this.medicalSupplyIdSet.add(medicalSupply?.id || medicalSupply?.medicalSupplyId);
    }

    initializeListMedicalSupply = medicalSupplies => {
        this.medicalSupplyIdSet = new Set();
        this.listMedicalSupply = [];
        if (medicalSupplies && medicalSupplies?.length > 0) {
            for (let i = 0; i < medicalSupplies.length; i++) {
                this.addMedicalSupply(medicalSupplies[i]);
            }
        }
    }

    removeMedicalSupply = medicalSupply => {
        if (!this.idValidMedicalSupply(medicalSupply)) return;
        if (this.medicalSupplyIdSet.has(medicalSupply?.id)) {
            this.medicalSupplyIdSet.delete(medicalSupply?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExist = medicalSupply => {
        if (!this.idValidMedicalSupply(medicalSupply)) return;
        return this.medicalSupplyIdSet.has(medicalSupply?.id);
    }

    getMedicalSupplyIdSet = () => {
        return this.medicalSupplyIdSet;
    }



    getListMedicalSupply = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listMedicalSupply && this.listMedicalSupply?.length > 0) {
            for (let i = 0; i < this.listMedicalSupply.length; i++) {
                const medicalSupply = this.listMedicalSupply[i];
                if (this.isExist(medicalSupply) && !bufferIdSet.has(medicalSupply?.id)) {
                    data.push(medicalSupply);
                    bufferIdSet.add(medicalSupply?.id);
                }
            }
        }
        this.listMedicalSupply = data;
        return data;
    }
    //end
}
